import { ref } from "vue";

const useVariant = () => {
  const variantId = ref("");
  const variantMenuOpen = ref(false);

  const setVariantId = (id) => {
    variantId.value = id;
  };

  const setMenu = (state) => {
    variantMenuOpen.value = state;
  };

  return { variantId, variantMenuOpen, setVariantId, setMenu };
};

export default useVariant;
